import { Redirect, useLocation } from "react-router-dom";
import { useHomSetupStatus } from "../../hooks/useHomSetupStatus";

const SETUP_HOME_PATH = "/reports/dashboard";

export function HomSetupGuard({ children, appType }) {
  const location = useLocation();
  const isHomsApp = appType?.startsWith("HOMS");
  const { isLoading, setupComplete } = useHomSetupStatus();

  if (!isHomsApp) {
    return children;
  }

  if (!setupComplete && !isLoading && location.pathname !== SETUP_HOME_PATH) {
    return <Redirect to={SETUP_HOME_PATH} />;
  }

  return children;
}

export default HomSetupGuard;
